<template>
    <div class="manage--content" ref="lesson-content">
      <div class="list-title-course-manage" :class="{isMB:isCheckedStatus}">
        <div class="titles clear" id="explore">
            <!-- <div class="title l title_course_rigth">{{titleCourse}}</div> -->
        </div>
      </div>
      <div class="tab" v-show="data.type == $CONST.COMMON.NUMBER.ZERO">
        <button :class="{active1: activeTab == $CONST.COMMON.NUMBER.TWO}" v-on:click="activeTab = $CONST.COMMON.NUMBER.TWO; checkPageCurrent()" class="btn-tab">{{$t('manage_lesson.info_course')}}</button>
        <button :class="{active1: activeTab == $CONST.COMMON.NUMBER.ZERO}" v-on:click="activeTab = $CONST.COMMON.NUMBER.ZERO; checkPageCurrent()" class="btn-tab">{{$t('manage.students')}}</button>
        <button :class="{active1: activeTab == $CONST.COMMON.NUMBER.ONE}" v-on:click="activeTab = $CONST.COMMON.NUMBER.ONE; checkPageCurrent()" class="btn-tab">{{$t('manage.questions')}}</button>
      </div>
      <div class="top-content">
        <h1 class="manage-title-content" v-show="data.type == $CONST.COMMON.NUMBER.ONE && typeClickQuestions == 1">{{$t("manage.detail")}}</h1>

        <div class="content__buttons">
          <!-- export certificate -->
          <button class="btn-tast" v-show="data.type == $CONST.COMMON.NUMBER.ONE && typeClickQuestions == 1" @click="exportCertificate()">
            <img src="../../../../static/images/icon_export.png" />
            <span class="nqt-text">{{ $t("studySituationList.certificate") }}</span>
          </button>

          <!-- Back -->
          <button class="btn-tast btn-next-1" v-show="data.type == $CONST.COMMON.NUMBER.ONE && typeClickQuestions == 1" v-on:click="back({courseId: data.courseId, type: $CONST.COMMON.NUMBER.ZERO})">
            <img src="../../../../static/images/icon-back-1.png"/>
            <span class="nqt-text">{{ $t("common.returnButton") }}</span>
          </button>
        </div>

        <!-- Search -->
        <div class="manage--search-content--left" v-show="data.type == $CONST.COMMON.NUMBER.ZERO && activeTab == $CONST.COMMON.NUMBER.ZERO">
            <input type="text" autocomplete="off" v-model="studentKeyName" v-on:keyup="filtterStudent()" :placeholder="$t('search.keyWord')" class="input--search-content--left"/>
            <button type="button" v-on:click="filtterStudent" class="button--search-content--left">
              <img :src="$CONST.HEADER.IMG.SEARCH"/>
            </button>
        </div>
      </div>
      <div v-if="data.type == $CONST.COMMON.NUMBER.ZERO && activeTab == $CONST.COMMON.NUMBER.ZERO" class="noteDot dtp">
          <span class="menu-switch-school lesson_begin" :value="lesson_begin" :class="{ 'menu-switch-school-on': lesson_begin }" @click="changeType('lesson_begin', !lesson_begin)"></span>
          <span @click="changeType('lesson_begin', !lesson_begin)">{{$t('week.undone')}}</span>
          <span class="menu-switch-school lesson_learning" :value="lesson_learning" :class="{ 'menu-switch-school-on': lesson_learning }" @click="changeType('lesson_learning', !lesson_learning)"></span>
          <span @click="changeType('lesson_learning', !lesson_learning)">{{$t('week.studing')}}</span>
          <span class="menu-switch-school lesson_end" :value="lesson_end" :class="{ 'menu-switch-school-on': lesson_end }" @click="changeType('lesson_end', !lesson_end)"></span>
          <span @click="changeType('lesson_end', !lesson_end)">{{$t('week.done')}}</span>
        </div>
      <div class="nqt-list-study" v-show="data.type == $CONST.COMMON.NUMBER.ZERO && activeTab == $CONST.COMMON.NUMBER.ZERO">
        <template v-for="(item, index) in students">
          <div class="nqt--card--student" :key="index" @click="showDetailStudent({id: item.id, type: $CONST.COMMON.NUMBER.ONE, status: item.status})" v-if="(((status == 99 && item.status == 0) || (status == 99 && item.status == 1) || (status == -2 && item.status == 0) || (status == -2 && item.status == 2) || (status == -3 && item.status == 1) || (status == -3 && item.status == 2)) || item.status == status || status == -1 ) && (type == item.isTeacher || type == 99)" :class="[{stBg: item.status == 0}, {stLn: item.status == 1}, {stEnd: item.status == 2}, {tooltip: !mobile}, {uio9: !mobile &&  item.studentSynopsis != null ? item.studentSynopsis.length > maxLengtText : false }]">
              <h1 class="nqt--card-title">{{item.userName}}</h1>
              <div class="div-nd-hv" style="height:auto">
                <template v-if="item.avatar==null">
                  <img class="avatar-hv" :src="item.sex == 2 ? avaDefault1:avaDefault" alt="avatar">
                </template>
                <template v-else>
                  <img class="avatar-hv" :src="item.avatar" alt="avatar">
                </template>
                <div class="nd-gt">
                  <div class="nqt--card-sex">
                    <label>{{$t('manage.sex')}}:</label>
                    <span class="lkt-h-20" v-if="item.sex == 1">{{$t('manage_student.male')}}</span>
                    <span class="lkt-h-20" v-if="item.sex == 2">{{$t('manage_student.female')}}</span>
                  </div>
                  <div class="nqt--card-startStudyDate">
                    <label>{{$t('new.title60')}}:</label>
                    <span class="lkt-h-20">{{item.startStudyDate}}</span>
                  </div>
                  <div class="nqt--card-endStudyDate">
                    <label>{{$t('new.title61')}}:</label>
                    <span class="lkt-h-20">{{item.endStudyDate}}</span>
                  </div>
                  <div class="nqt--card-endStudyDate">
                    <label>{{$t('home.status')}}:</label>
                    <span class="lkt-h-20">{{getNameStatus(item)}}</span>
                  </div>
                  <template v-if="mobile">
                    <div class="nqt--card-endStudyDate">
                      <label>{{$t('manage.discription')}}</label>
                    </div>
                    <div style="font-size: 13px;">{{item.studentSynopsis}}</div>
                  </template>
                </div>
              </div>
              <template v-if="!mobile">
                <span class="lkt-label" style="margin-top:5px" >{{$t('manage.discription')}}</span>
                <div>
                  <div class="lkt-description" style="-webkit-box-orient: vertical !important;">
                    <span v-html="item.studentSynopsis" style="font-size: 13px;"></span>
                  </div>
                </div>
                <span v-if="!mobile && item.studentSynopsis != null && item.studentSynopsis.length > nqt__length" class="tooltiptext" v-html="item.studentSynopsis"></span>
              </template>
          </div>
        </template>
      </div>
      <!-- Load component detail course -->
      <detailCourse v-if="data.type == $CONST.COMMON.NUMBER.ZERO && activeTab == $CONST.COMMON.NUMBER.TWO" :data="data"></detailCourse>
      <!-- Load component detail -->
      <statictical v-if="data.type == $CONST.COMMON.NUMBER.ONE" v-on:clickTypeNonLesson="clickTypeNonLesson($event)" :data="data"></statictical>
      <!-- Load component questions -->
      <question v-if="activeTab == $CONST.COMMON.NUMBER.ONE" :data="data" @update-type="updateType" @listQuestionsCourse="listQuestionsCourse"></question>
      <loading class="loading--lesson" :showLoading="!isLoadData" />
    </div>
</template>

<script>
import statictical from "@/components/manage/statictical";
import question from "@/components/manage/question";
import detailCourse from "@/components/manage/detailCourseInManagerCourse";
import loading from "@/components/loading/loading";
export default {
  data() {
    return {
      isLoadData: false,
      nqt__length: 263,
      studentKeyName: this.$CONST.COMMON.STRING.IS_NULL,
      students: [],
      lists: [],
      status: 99,
      lesson_begin: true,
      lesson_learning: true,
      lesson_end: false,
      type: 99,
      showNqt: false,
      activeTab: this.$CONST.COMMON.NUMBER.TWO,
      titleCourse: "",
      isCheckedStatus: false,
      maxLengtText: 115,
      avaDefault: "static/images/profile.jpg",
      avaDefault1: "static/images/SA-ava-nu.png",
      typeClickQuestions: 1,
    };
  },
  components: {
    statictical,
    question,
    detailCourse,
    loading
  },
  computed: {
    mobile () {
      return this.$store.getters['header/mobile'];
    }
  },
  props: {
    data: {
      type: Object,
      default: {}
    }
  },
  created () {
    if (!this.data.courseId) return;
    if (this.data.list==null) {
      this.$api
      .post("/collegecourse/getAllStudent", {
        courseId: this.data.courseId
      })
      .then((response) => {
          if (response.data) {
            this.data.list = response.data;
            let dataListStudentsCourse = {};
            dataListStudentsCourse.courseId = this.data.courseId;
            dataListStudentsCourse.list = response.data;
            this.$emit("listStudentsCourse", dataListStudentsCourse);
            this.getStatisticStudents(response.data);
            this.isLoadData = true;
          }
      })
      .catch((err) => {});
    } else {
      this.isLoadData = true;
      if (this.data.list.length) {
        this.getStatisticStudents(this.data.list);
      }
    }
    if(this.data.checkBackStudent){
      this.activeTab = this.$CONST.COMMON.NUMBER.ZERO;
    }
    this.nqt__length = this.$lang() == 4 || this.$lang() == 2 ? 263 : 120;
    this.init();
  },
  watch: {
    status (value) {
      if (value == -1) {
        this.lesson_begin = true;
        this.lesson_learning = true;
        this.lesson_end = true;
      }
      if (value == 99) {
        this.lesson_begin = true;
        this.lesson_learning = true;
        this.lesson_end = false;
      }
      if (value == -99) {
        this.lesson_begin = false;
        this.lesson_learning = false;
        this.lesson_end = false;
      }
      if (value == -2) {
        this.lesson_begin = true;
        this.lesson_learning = false;
        this.lesson_end = true;
      }
      if (value == 0) {
        this.lesson_begin = true;
        this.lesson_learning = false;
        this.lesson_end = false;
      }
      if (value == 1) {
        this.lesson_begin = false;
        this.lesson_learning = true;
        this.lesson_end = false;
      }
      if (value == 2) {
        this.lesson_begin = false;
        this.lesson_learning = false;
        this.lesson_end = true;
      }
    }
  },
  methods: {
    clickTypeNonLesson(params){
      this.typeClickQuestions = params;
    },
    listQuestionsCourse(data){
      let listQuestionCourse = {};
      listQuestionCourse.listQuestions = data;
      listQuestionCourse.courseId = this.data.courseId
      this.data.listQuestion = data;
      this.$emit("listQuestionsCourseManage", listQuestionCourse);
    },
    checkPageCurrent(){
      window.sessionStorage.setItem("checkPageCurrent", false);
    },
    _isMobile() {
      let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
      );
      return flag;
    },
    getNameStatus: function (params) {
      var name = "";
      if (params.startStudyDate!=null&&params.endStudyDate!=null||params.startStudyDate==null&&params.endStudyDate!=null) {
        name = this.$t('manage_student.lesson_end');
      } else if (params.startStudyDate!=null&&params.endStudyDate==null) {
        name = this.$t('manage_student.lesson_locked_not_study_end');
      } else {
        name = this.$t('manage_student.lesson_unlocked');
      }
      return name;
    },
    updateType(type){
      if(type==this.$CONST.COMMON.NUMBER.ONE) {
        $(".manage--content .tab").addClass("display_questions");
        $(".title_manager_questions").addClass("display_questions");
      } else {
        $(".manage--content .tab").removeClass("display_questions");
        $(".title_manager_questions").removeClass("display_questions");
      }
    },
    init: function () {
      this.titleCourse = this.data.nameCourse;
      if (this._isMobile()) {
        this.isCheckedStatus = true;
      } else {
        this.isCheckedStatus = false;
      }
    },
    filtterStudent: function () {
      const keyword = this.studentKeyName.toUpperCase();
      if (keyword == this.$CONST.COMMON.STRING.IS_NULL || keyword == this.$CONST.COMMON.STRING.IS_BLANK) {
        this.students = this.data.list;
        return;
      }
      this.students = this.data.list.filter(student => student.userName.toUpperCase().indexOf(keyword) > -1 || (student.studentSynopsis != null && student.studentSynopsis.toUpperCase().indexOf(keyword) > -1));
    },
    showDetailStudent: function (params) {
      if(params.status==0){
        this.$confirm(window.vm.$i18n.t("new.title94"), window.vm.$i18n.t("new.title86"), { cancelButtonClass: "btn-nqt---show" })
          .then(() => {})
          .catch(() => {});
      } else {
        /// select details
        let data = {
          id: params.id,
          type: params.type
        }
        this.$emit("showDetailStudent", data);
      }
    },
    // export certificate for student
    exportCertificate () {
      const listStudent    = this.data.purchaseDetails.studentList;
      const temp           = listStudent.filter(student => this.data.studentId == student.id);
      const currentStudent = temp[0];

      if(!currentStudent.endStudyDate) {
        return this.$message.warning(window.vm.$i18n.t("manage.msgExportCer"));
      }

      this.$api
        .post("/home/certificateExport", {
          id             : this.data.courseId,
          courseName     : this.data.nameCourse,
          courseLanguage : this.$lang(),
          area           : this.$lang(),
          name           : currentStudent.userName,
          gender         : currentStudent.sex,
          companyId      : window.sessionStorage.getItem("companyId"),
          jobs           : currentStudent.job
        })
        .then((response) => {
          if (response.data != null) {
            window.open(response.data);
          } else {
            this.$message.warning(window.vm.$i18n.t("js.certificateDataNone"));
          }
        })
        .catch((error) => {});
    },
    back: function (params) {
      this.$emit("back", params);
    },
    getStatisticStudents: function (data) {
      data.forEach(item => {
        item.startStudyDate != null ? item.startStudyDate = item.startStudyDate.slice(0, 10) : item.startStudyDate;
        item.endStudyDate != null ? item.endStudyDate = item.endStudyDate.slice(0, 10) : item.endStudyDate;
        let status = 0;
        status = item.startStudyDate != null ? 1 : status;
        status = item.endStudyDate != null ? 2 : status;
        item['status'] = status;
        if (item.startStudyDate==null&&item.endStudyDate!=null) {
          item.examStatus = "99";
        }
      });
      this.students = data;
    },
    // getStatus: function (param) {
    //   const self = this;
    //   return new Promise((resolve, reject) => {
    //       this.$api
    //       .post("/courseStudy/getExamStatus", {
    //           courseId: self.data.courseId,
    //           studentId: param.id
    //       })
    //       .then((response) => {
    //           param['examStatus'] = response.data;
    //           resolve(param);
    //       }).catch(err => {
    //       });
    //   });
    // },
    changeType: function (name, value) {
      this[name] = value;
      if (this.lesson_begin) {
        this.status = 0;
      }
      if (this.lesson_learning) {
        this.status = 1;
      }
      if (this.lesson_end) {
        this.status = 2;
      }
      if (this.lesson_begin && this.lesson_learning) {
        this.status = 99;
      }
      if (this.lesson_begin && this.lesson_end) {
        this.status = -2;
      }
      if (this.lesson_learning && this.lesson_end) {
        this.status = -3;
      }
      if (this.lesson_begin && this.lesson_learning && this.lesson_end) {
        this.status = -1;
      }
      if (!this.lesson_begin && !this.lesson_learning && !this.lesson_end) {
        this.status = -99;
      }
    },
  }
};
</script>
<style scoped>
.content__buttons {
  display: flex;
}
/* Tooltip text */
.tooltip .tooltiptext {
  visibility: hidden;
  width: auto;
  background-color: black;
  color: #fff;
  text-align: center;
  padding: 5px;
  border-radius: 6px;

  /* Position the tooltip text - see examples below! */
  position: absolute;
  z-index: 1;
  top: 100%;
      
}

.tooltip .tooltiptext::after {
  content: " ";
  position: absolute;
  bottom: 100%;  /* At the top of the tooltip */
  left: 50%;
  margin-left: -5px;
  border-width: 5px;
  border-style: solid;
  border-color: transparent transparent black transparent;
}

/* Show the tooltip text when you mouse over the tooltip container */
.uio9:hover .tooltiptext {
  visibility: visible;
}
.uio9 {
  -webkit-box-orient: vertical !important;
}
.avatar-hv{
  width: 120px;
  height: 120px;
  object-fit: contain;
}
.nqt--card-discription {
    display: -webkit-box !important;
    -webkit-box-orient: vertical !important;
    padding: 0 0 0 5px!important;
    overflow: hidden !important;
    color: #333!important;
    -webkit-line-clamp: 3!important;
    /* line-height: 18px;
    width: 100%;
    margin-bottom: 15px; */
  }
.lkt-h-20 {
  height: 20px;
}
.lkt-label{
  font-style:normal;
  padding-right:5px;
  font-size: 13px;
  font-weight: bold;
}
.lkt-description{
  -webkit-line-clamp: 4 !important;
  font-size: 14px !important;overflow: hidden !important;
  display: -webkit-box !important;
  line-height: 18px !important;
  -webkit-box-orient: vertical !important; 
}
.nqt--card--student {
  cursor: pointer;
  border: 1px solid #d7d7d7;
  position: relative;
}
.nqt--card--student label {
  cursor: pointer;
  width: 145px;
}

.display_questions {
  display: none;
}
.title_course_rigth {
  text-align: center;
  font-weight: unset!important;;
}
.list-title-course-manage .titles .title {
    text-transform: uppercase;
    line-height: 26px !important;
    font-size: 24px;
    width: calc(100% - 50px);
    margin-bottom: 10px;
}
.isMB {
  display: none;
}

/* ---------- */

  .nqt--title {
    text-align: center;
    margin: 10px auto;
    text-transform: uppercase;
  }
  .stBg .nqt--card-title{
    color: #1f1313;
  }
  .stLn .nqt--card-title{
    color: #da251d;
  }
  .stEnd .nqt--card-title{
    color: #118e07;
  }
  .unactive {
    filter: grayscale(100%);
  }
  .select-new {
    width: 25% !important;
  }
  .select-new.mobile {
    width: 100% !important;
    margin-top: 1rem;
  }
  .dtp {
    margin-top: 20px;
    float: none;
  }
  .dot--lesson_begin {
    background: #1f1313;
  }
  .dot--lesson_learning {
    background: #da251d;
  }
  .dot--lesson_end {
    background: #118e07;
  }

  .noteDot span {
    padding-left: 10px;
    padding-right: 20px;
    cursor: pointer;
  }

  /* switch */
  .menu-switch-school {
    display: block;
    position: relative;
    width: 46px;
    height: 27px;
    border: 1px solid #dfdfdf;
    outline: 0;
    border-radius: 16px;
    box-sizing: border-box;
    background-color: #dfdfdf;
    transition: background-color 0.1s, border 0.1s;
    cursor: pointer;
  }
  .menu-switch-school:before {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 44px;
    height: 25px;
    border-radius: 15px;
    transition: transform 0.35s cubic-bezier(0.45, 1, 0.4, 1);
  }
  .menu-switch-school:after {
    content: " ";
    position: absolute;
    top: 0;
    left: 0;
    width: 24px;
    height: 24px;
    border-radius: 15px;
    background-color: #ffffff;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.4);
    transition: transform 0.35s cubic-bezier(0.4, 0.4, 0.25, 1.35);
  }
  .menu-switch-school-on {
    border-color: #79c9ff;
    background-color: #79c9ff;
  }
  .lesson_begin.menu-switch-school-on:before {
    border-color: #1f1313;
    background-color: #1f1313;
  }
  .lesson_learning.menu-switch-school-on:before {
    border-color: #da251d;
    background-color: #da251d;
  }
  .lesson_end.menu-switch-school-on:before {
    border-color: #118e07;
    background-color: #118e07;
  }
  .menu-switch-school-on:after {
    transform: translateX(20px);
  }
  /* .controlType {
    display: flex
  } */
  .controlType .dtp {
    margin-top: 0;
    margin-left: 20px;
  }
  @media (max-width:480px) {
    .nd-gt div {
      flex-wrap: inherit;
    }
  }
</style>


// WEBPACK FOOTER //
// src/components/manage/content/lessons.vue